import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=19109569&scoped=true&"
import script from "./QuestionPreview.vue?vue&type=script&lang=js&"
export * from "./QuestionPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&id=19109569&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19109569",
  null
  
)

export default component.exports